const languagePack = {

    seo: {
        home: {
            title: "ROY GYM | Konditerem Székesfehérvár ",
            description:
                "Modern konditerem Székesfehérváron: Pilates, Köredzés, TRX, alakformáló, stretching & mobilitás, funkcionális edzés, személyi és csoportos tréningek."
        },
        services: {
            title: "Szolgáltatások | ROY GYM Székesfehérvár",
            description:
                "Válogass óráink és edzéseink közül: Pilates, Köredzés, TRX, alakformáló, stretching & mobilitás, funkcionális edzés és személyi edzés."
        },
        pricelist: {
            title: "Árlista | ROY GYM – Bérletek és jegyek",
            description:
                "Jegyek és bérletek árai: napijegy, havi bérlet, 10 alkalmas, 3/6/12 havi bérlet, diák és nyugdíjas kedvezmények."
        },
        about: {
            title: "Rólunk | ROY GYM – Modern konditerem",
            description:
                "Ismerd meg a Roy Gym csapatát és a családias hangulatot. Modern géppark, támogató közösség, edzés kezdőtől haladó szintig."
        },
        news: {
            title: "Hírek | ROY GYM",
            description:
                "Aktuális hírek, események, akciók és újdonságok a Roy Gymből. Kövesd, mi történik a teremben és a közösségben."
        },
        trainers: {
            title: "Edzők | ROY GYM – Személyi edzés",
            description:
                "Ismerd meg személyi edzőinket: profilok, elérhetőségek, specialitások. Segítség fogyáshoz, izomépítéshez és életmódváltáshoz."
        },
        timetable: {
            title: "Órarend | ROY GYM – Csoportos órák",
            description:
                "Nézd meg a csoportos órák aktuális órarendjét. Időpontok, frissítések és fontos tudnivalók egy helyen a tervezéshez."
        },
        gallery: {
            title: "Galéria | ROY GYM",
            description:
                "Fotók a Roy Gymből: terem, géppark, órák és hangulat. Nézz körül, ismerd meg a helyet, mielőtt ellátogatsz hozzánk."
        },
        career: {
            title: "Karrier | ROY GYM – Álláslehetőségek",
            description:
                "Nyitott pozíciók a Roy Gymnél: személyi edzők, takarítók és egyéb lehetőségek. Jelentkezés, feltételek és elérhetőségek."
        },
        company: {
            title: "Impresszum | ROY GYM",
            description:
                "Cégadatok és tárhelyszolgáltató információk a Roy Gym weboldalához. Kapcsolati és jogi információk egy helyen."
        },

        // Optional (recommended): noindex these pages
        notfound: {
            title: "404 – Az oldal nem található | ROY GYM",
            description:
                "A keresett oldal nem található. Kérjük, ellenőrizd a címet, vagy térj vissza a főoldalra."
        },
        error: {
            title: "Hiba történt | ROY GYM",
            description:
                "Technikai hiba történt az oldal betöltése közben. Kérjük, próbáld meg újra később, vagy térj vissza a főoldalra."
        }
    },
    notfound: {
        title: "Hoppá!",
        message: "Ez az oldal nem létezik!",
        backhome: "Vissza a főoldalra"
    },
    error: {
        title: "Hiba történt",
        message: "Hibaüzenet: ",
        backhome: "Vissza a főoldalra",
    },
    common: {
        loading: "Töltés",
        loadingOptions: [
            "Izmok betöltése…",
            "Tárcsák a rúdra…",
            "Ismétlések számlálása…",
            "Proteinshake rázása…",
            "Pad törlése folyamatban…",
            "+1 ismétlés a szerencséért…",
            "Magnesia a rúdra…",
            "Az utolsó sorozat kipréselése…",
            "Kulacs újratöltése…",
            "Pózolás a tükörben…",
            "Edzés előtti megivása…",
            "Regenerálódás folyamatban…",
            "Vitaminok adagolása",
            "Csirke sütése…",
            "Láb napra felkészülés…",
            "Bicepszek durrantása…",
            "Szuperszett kezdése…"
        ]
    },

    hero: {
        h1: "Modern konditerem Székesfehérváron – ROY GYM",
        p: "Pilates, Köredzés, TRX, Alakformáló, Stretching & mobilitás, Funkcionális edzések, valamint személyi és csoportos tréningek. Edzőtermük továbbá profi gépparkot kínál."
    },

    nav: {
        about: "Rólunk",
        services: "Szolgáltatások",
        servicesDropdown: {
            pilates: "Pilates",
            koredzes: "Köredzés",
            trx: "TRX",
            alakformalo: "Alakformáló edzés",
            mobilitas: "Stretching & mobilitás",
            funkcionalis: "Funkcionális edzés",
            szemelyiedzes: "Személyi edzés"
        },
        gallery: "Galéria",
        trainers: "Edzők",
        contact: "Kapcsolat",
        news: "Hírek",
        pricelist: "Árlista",
        timetable: "Órarend",
        career: "Karrier"
    },
    home: {
        hero: {
            slogen: "Érezd, hogy tartozol valahová",
            newcomer: "Új vagy nálunk?",
            scrollcue: "Görgess tovább"
        },
        pricelist: {
            title: "Ajánlatunk",
            viewFull: "Teljes árlista megtekintése"
        },
        services: {
            title: "Válogass szolgáltatásaink közül",
            viewFull: "Összes szolgáltatásunk"
        },
        trainers: {
            title: "Segítünk céljaid elérésében",
            viewFull: "Összes személyi edző"
        }
    },
    career: {
        title: "Karrier",
        subtitle: "Csatlakozz a RoyGym csapatához!",
        intro:
            "Folyamatosan keressük a lendületes, elkötelezett munkatársakat, akik osztoznak a sport és az egészséges életmód iránti szenvedélyünkben.",
        positionsTitle: "Aktuális lehetőségek",
        positions: {
            trainer: {
                title: "Személyi edzők",
                desc:
                    "Tapasztalt, motivált szakembereket várunk, akik vendégeink fejlődését segítik; az edzőknek nincs külön fizetés.",
                info:
                    "Fontos tudnivaló: a személyi edzők részére nincs leadó vagy bérleti díj, csupán annyi a feltétel, hogy a vendég érvényes napi jeggyel vagy bérlettel rendelkezzen.",
                exception:
                    "Kivétel: ha az edző csoportos órát tart, amely bekerül a hivatalos órarendbe, külön megállapodás szükséges."
            },
            cleaner: {
                title: "Takarítók",
                desc:
                    "Igényes és megbízható munkatársakat keresünk, akik hozzájárulnak a terem tisztaságához és higiéniai színvonalához."
            }
        },
        applyTitle: "Jelentkezés",
        applyDesc:
            "Ha szeretnél egy profi és barátságos csapat tagja lenni, küldd el fényképes önéletrajzodat a következő e-mail címre:",
        phoneDesc: "Kérdés esetén hívj minket bátran:"
    },
    news: {
        title: "Hírek",
        loading: "Hírek betöltése...",
    },
    timetable: {
        title: "Órarend",
        loading: "Órarend betöltése..."
    },
    pricelist: {
        title: "Árlista",
        sections: {
            adult: {
                title: "Felnőtt bérletek és jegyek",
                items: [
                    { name: "Napijegy", price: "2 000 Ft", desc: "Egyszeri belépésre jogosít, az adott napon belépés után a konditerem teljes körű használatára." },
                    { name: "Havi bérlet", price: "17 000 Ft", desc: "30 napig érvényes, korlátlan belépést biztosít a konditerembe az érvényességi idő alatt." },
                    { name: "10 alkalmas bérlet", price: "17 000 Ft", desc: "60 napig érvényes, összesen 10 belépésre jogosít." },
                    { name: "3 havi bérlet", price: "46 000 Ft", desc: "90 napig érvényes, korlátlan belépéssel." },
                    { name: "6 havi bérlet", price: "88 000 Ft", desc: "180 napos korlátlan hozzáférés a konditeremhez." },
                    { name: "12 havi bérlet", price: "166 900 Ft", desc: "Teljes éves bérlet, napi szintű edzéshez." },
                ]
            },
            discount: {
                title: "Diák és Nyugdíjas bérletek",
                items: [
                    { name: "Napijegy", price: "2 000 Ft", desc: "Egyszeri belépésre jogosít." },
                    { name: "Havi bérlet", price: "14 000 Ft", desc: "30 napos korlátlan belépés diákoknak és nyugdíjasoknak." },
                    { name: "10 alkalmas bérlet", price: "14 000 Ft", desc: "60 napig érvényes, 10 alkalomra jogosít." },
                    { name: "3 havi bérlet", price: "36 000 Ft", desc: "90 napig érvényes korlátlan belépéssel." },
                    { name: "6 havi bérlet", price: "71 000 Ft", desc: "180 napig érvényes, bármikor használható." },
                    { name: "12 havi bérlet", price: "138 000 Ft", desc: "360 napig érvényes, egész évre biztosít belépést." }
                ]
            },
            group: {
                title: "Csoportos edzés",
                note: [
                    "A csoportos bérlet edzés előtt és után a konditerem használatára is jogosít.",
                    "Minden alkalommal kérjük, hozd magaddal a bérletedet.",
                    "Előzetes bejelentkezés szükséges a helyek biztosítására."
                ],
                items: [
                    { name: "1 alkalmas jegy", price: "3 000 Ft", desc: "Egyszeri részvétel bármelyik csoportos edzésen." },
                    { name: "5 alkalmas bérlet", price: "13 500 Ft", desc: "30 napig érvényes, 5 alkalom." },
                    { name: "10 alkalmas bérlet", price: "27 000 Ft", desc: "60 napig érvényes, 10 alkalom." }
                ]
            },
        },
        footer: "Minden ár forintban értendő és tartalmazza az ÁFA-t.",
        specialDiscount: "Különleges kedvezmény!",

    },
    services: {
        title: "Szolgáltatások",

        pilates: {
            name: "Pilates",
            desc:
                "A pilates egy mélyizom-erősítő, nyugodt tempójú mozgásforma, amely a törzs stabilizáló izmaira, testtartásra és a légzésre helyezi a hangsúlyt. Kiváló választás, ha szeretnéd erősíteni a has- és hátizmaidat, javítani a testtartásodat, enyhíteni a derék- vagy hátfájdalmakat, és mentálisan is feltöltődni. Kezdők és haladók számára is ajánlott, kíméletes, de nagyon hatékony edzésforma."
        },

        koredzes: {
            name: "Köredzés",
            desc:
                "A köredzés egy hatékony és változatos edzésforma, ahol többféle gyakorlatot végzel egymás után, különböző állomásokon. Kombinálja az erő- és állóképesség-fejlesztést, javítja a testkompozíciót, gyorsítja az anyagcserét és fokozza a zsírégetést. Mindig változatos, így nem válik unalmassá, és bármilyen edzettségi szinten elkezdhető."
        },

        cardiowalk: {
            name: "Cardiowalk",
            desc:
                "A Cardiowalk egy egyedülálló, dinamikus edzésforma, amely az intenzív gyaloglás és a ritmusos zene erejét ötvözi. Az órák során emelkedőkkel, változó tempókkal és folyamatos instrukciókkal dolgozunk, hogy fokozzuk a zsírégetést, formáljuk az alsótest izmait, és javítsuk az állóképességet. Az edzés kifejezetten alkalmas mindazoknak, akik nem kedvelik az ugrálós vagy túlzottan megerőltető mozgásformákat, de mégis szeretnének egy hatékony, lendületes és ízületkímélő mozgásélményt."
        },

        trx: {
            name: "TRX",
            desc:
                "A TRX egy felfüggesztéses eszköz, amellyel saját testsúllyal végzett gyakorlatokat végzünk. Kiemelkedően fejleszti a törzsstabilitást, az erőt, az egyensúlyt és a koordinációt. Nagy előnye, hogy az intenzitás könnyen szabályozható, így kezdők és haladók is megtalálják benne a kihívást."
        },

        alakformalo: {
            name: "Alakformáló edzés",
            desc:
                "Célzott gyakorlatokkal dolgozunk a női problémás területekre: has, comb, popsi, kar. Az edzések során váltogatjuk az erősítő és zsírégető blokkokat, így hatékonyan formáljuk az alakot és fokozzuk a feszességet. Ideális választás, ha szeretnél tónusosabb testet és jobb közérzetet."
        },

        mobilitas: {
            name: "Stretching & mobilitás",
            desc:
                "A nyújtás és mobilizálás kulcsfontosságú az egészséges mozgástartomány és a sérülésmegelőzés szempontjából. Ezeken az órákon a hajlékonyság fejlesztése mellett segítünk levezetni a feszültséget, oldani az izmok merevségét és javítani a testtudatot. Ajánlott más edzések kiegészítéseként is."
        },

        funkcionalis: {
            name: "Funkcionális edzés",
            desc:
                "Ez az edzésforma a mindennapi mozgásmintákra épül – guggolás, emelés, húzás, tolás –, és javítja a test teljesítőképességét. Saját testsúllyal, súlyzókkal, kettlebell-lel vagy más eszközökkel dolgozunk. Fejleszti az erőt, állóképességet, koordinációt és egyensúlyt – igazi \"teljes test\" edzés."
        },

        szemelyiedzes: {
            name: "Személyi edzés",
            desc:
                "Ha egyénre szabott figyelmet szeretnél, segítünk személyi edzés keretében elérni a céljaidat – legyen szó fogyásról, izomtömeg-növelésről, rehabilitációról vagy életmódváltásról. Az edzéseket teljes mértékben rád szabjuk, és végigkísérünk a fejlődésed útján. Választott edződ ott lesz melletted minden lépésnél."
        }
    },
    about: {
        title: "Rólunk",
        intro: "Üdvözlünk az edzőtermünkben – ahol nemcsak az izmok, hanem a közösség is erősödik!",
        team: "Mi vagyunk Roland, Daniella, 2 lelkes és elhivatott ember, akik nemcsak a sport, hanem az emberek iránti szenvedélyüket is ebben a teremben valósítják meg. Az edzőterem megnyitásával egy olyan helyet álmodtunk meg, ahol mindenki otthon érezheti magát – legyen kezdő vagy haladó, fiatal vagy idősebb.",
        familyAtmosphere: "Nálunk a családias légkör nem csak egy üres kifejezés. Törődünk vendégeinkkel, ismerjük egymást név szerint, és fontos számunkra, hogy mindenki támogatást kapjon – akár célja egy életmódváltás, fogyás, erőnlétfejlesztés, vagy egyszerűen csak egy stresszmentes mozgásforma megtalálása.",
        groupClasses: "Változatos csoportos óráinkkal is várunk, amelyekből mindenki megtalálhatja a hozzá illőt – legyen szó zsírégetésről, erősítésről, mobilitásfejlesztésről vagy feltöltő, energizáló mozgásformákról.",
        membership: "A csoportos órákra kedvezményes bérleteket kínálunk, és lehetőség van alkalmi részvételre is, így mindenki a saját időbeosztásához és igényeihez igazíthatja az edzéseit.",
        philosophy: "Hiszünk abban, hogy az edzés nemcsak a testet, hanem a lelket is formálja. Ezért különös figyelmet fordítunk arra, hogy motiváló, barátságos és inspiráló közeget teremtsünk, ahol mindenki bátran léphet be az ajtón – előítéletek és megfelelési kényszer nélkül.",
        invitation: "Gyere el, próbáld ki, ismerj meg minket, és légy része egy támogató közösségnek, ahol együtt haladunk a céljaid felé!"
    },
    gallery: {
        title: "Galéria",
        loading: "Galéria betöltése..."
    },
    trainers: {
        title: "Edzők",

        /* Labels you’ll reuse in every profile (good for easy localisation) */
        labels: {
            phone: "Telefon",
            email: "E-mail",
            instagram: "Instagram"
        },

        /* ----------------------------------------------------------------
           Individual trainers
           key   → used in JSX      trainers.find(t => t.key === "trainer_janika")
           name  → shows on card & modal header
           phone/email/instagram → consistent contact row
           bio   → unlimited free-text, can hold line-breaks & emojis
        ----------------------------------------------------------------- */
        list: {
            // janika: {
            //     name: "Deme János",
            //     phone: "+36 20 373 4111",
            //     email: "demejani@icloud.com",
            //     instagram: "@deme_jani",
            //     bio: "Sziasztok, Deme János vagyok.\n\n10 éve kezdtem el a súlyzós edzést, ami az életem szerves része lett. Ebből 3 év versenyzés és 3 év versenyfelkészítő edzőként tevékenykedem.\n\n🏆 Wabba Junior BB 🥇\n🏆 Wabba Athletic BB 🥇\n🏆 Wabba Short BB 🥇\n\n2021-ben elvégeztem az IWI Nemzetközi Fitnesziskolát. Sportoktató, Testépítő-fitnesz, Versenyfelkészítő szakágon végeztem.\n\n4 éve dolgozom főállású edzőként. Kortól, céltól, nemtől függetlenül foglalkozom minden sportolni vágyó emberrel. Versenyfelkészítő edzőként is sikeres eredményeket, aranyéremig is eljutottunk – légy te a következő!\n\n💰 *Edzés árak*\n• Személyi edzés: 5 000 Ft/alkalom\n• Páros edzés: 3 500 Ft/fő/alkalom\n\n8 alkalmas bérlet: 35 000 Ft\n10 alkalmas bérlet: 40 000 Ft\n12 alkalmas bérlet: 45 000 Ft\nDiákoknak 5 000 Ft kedvezmény!\n\n*Étrend*\n20 000 Ft • Bérleteseknek 15 000 Ft\n\nÉn mutatom az utat, aki járja, eléri célját!\n\nÉrdeklődj üzenetben vagy telefonon."
            // },

            roland: {
                name: "Fehér Roland",
                phone: "+36 30 491 9340",
                email: "apika89305@gmail.com",
                instagram: "@fit_by_roy",
                image: "roland.jpg",
                bio: "Sziasztok! Fehér Roland vagyok, a Roy Gym tulajdonosa.\n\nVállalkozó, 10 éve személyi- és csoportos edző, versenyző. Aki ismer, az tudja, hogy az edzői tevékenységem számomra nem munka, hanem hivatás – ez köré épül az életem szellemileg, testileg és lelkileg.\n\nSikereimet annak köszönhetem, hogy vendégeim céljait helyezem előtérbe, és ahhoz alkalmazkodva kísérem őket a legjobb tudásom szerint. Szeretnék a lehető legtöbb embernek egészséges életmódot adni és a rohanó világban kikapcsolódást nyújtani.\n\n────────────────────────────\n💡 *Mit tudok adni?*\n\n• **Életmód- és táplálkozási tanácsadás** – személyre szabott, napi rutinhoz igazított étkezési formák, receptek, praktikák a hosszú-távú fejlődésért.\n\n• **Személyi edzés** (5 000 Ft/alkalom) – 1:1, 60 perc folyamatos figyelem, állapotfelmérés után veled és céljaiddal hangolva. Pilates- és TRX-opcióval.\n\n• **Páros edzés** (3 500 Ft/fő/alkalom) – barátoknak, pároknak, családtagoknak. Könnyen követhető, mégis pörgős 60 perc közös feladatokkal.\n\n• **Csoportos edzés** (2 500 Ft/fő/alkalom) – köredzés több állomással, súlyzó, TRX, gumiszalag, step-pad, instabil eszközök stb. Kezdőknek és haladóknak egyaránt.\n\nInduljunk el együtt a változás útján, és alkossunk maradandót, ami elkísér az életed során! 🙏\n\nÉrdeklődj üzenetben, vagy a +36 30 491 9340-es telefonszámon.\nE-mail: apika89305@gmail.com\nInstagram: @fit_by_roy"
            },

            daniella: {
                name: "Bakos Daniella",
                phone: "+36 30 959 2613",
                email: "mailto:daniellabakos6@gmail.com",
                instagram: "https://instagram.com/daniella_bakos",
                image: "daniella.jpg",
                bio:
                    "Sziasztok!\n\n" +
                    "Bakos Daniella vagyok, személyi és páros edző, valamint a Roy Gym tulajdonosa.\n" +
                    "6 éve a testépítés az életem része, 3 éve pedig a bikini fitness kategóriában versenyzem, és rangos eredményeket értem el.\n" +
                    "Számomra ez nem csak sport: ez az életstílusom, a szenvedélyem, ami átjárja a mindennapjaimat. És pont ezt a szenvedélyt szeretném átadni neked is, hogy megtaláld a saját erődet, a magabiztosságodat, és élvezd, hogy a tested és az egész életed megváltozik.\n\n" +
                    "Nem hiszek a sablonokban. Mindenkit úgy kezelek, mintha a saját céljaiért dolgoznék: figyelek rád, meghallgatom a tested, a lelked és a gondolataid, és a programot teljesen hozzád igazítom – hogy az edzés ne legyen egy \"muszáj\" rutin, hanem élmény, ami formál, energikussá tesz, és jobbá teszi a viszonyodat önmagaddal.\n\n" +
                    "Amit tőlem kaphatsz:\n" +
                    "– Életmód- és táplálkozási tanácsadás\n" +
                    "Valódi, fenntartható megoldások, nem egy újabb \"csodadiéta\".\n" +
                    "Finom, pénztárca- és időkimélő receptek, praktikus tippek és apró trükkök, amelyek nemcsak hozzád, hanem akár a családod mindennapjaihoz is tökéletesen illeszkednek.\n\n" +
                    "– Személyi edzés – 6.000 Ft / alkalom\n" +
                    "Csak rád figyelek 60 percen át. Legyen szó formálásról, erősítésről vagy regenerálásról, minden mozdulat a te céljaidért történik.\n\n" +
                    "– Páros edzés – 3.000 Ft / fő / alkalom\n" +
                    "Ha szeretnéd, hogy valaki melletted álljon, aki hisz benned akkor is, amikor te kételkedsz – itt vagyok!\n" +
                    "Baráttal, barátnővel, pároddal vagy akár szüleiddel/gyermekeddel is edzhetsz, és garantálom, hogy minden alkalom motiváló, élménydús és jó hangulatú lesz.\n\n" +
                    "Először csak egy órát veszünk el a napodból – de az az egy óra megváltoztathatja az egész életedet. Ahogy telik az idő, te csak erősebb, magabiztosabb és energikusabb leszel. Ha szeretnél egy órára kizökkenni a hétköznapokból, csak magaddal foglalkozni, közben átalakulni, és még élvezni is a folyamatot, keress bátran, és vágjunk bele együtt!\n\n" +
                    "8000 Székesfehérvár, Budai út 154.\n" +
                    "Roy GYM edzőterem",
            },

            eszter: {
                name: "Pataki Eszter",
                phone: "+36 70 380 9749",
                email: "f.patakieszter@gmail.com",
                instagram: "",
                image: "eszter.jpg",
                bio: "Ferkócza Pataki Eszter vagyok. \n\nPécsett végeztem a Pécsi Tudományegyetem Természettudományi Kar Személyügyi Szervező Szakán. \n\nAz egész életemet áthatja a sport szeretete. Gyermekként balettoztam, majd évekig lovagoltam. Az alakformáló és csoportos fitnesz órák az életem részévé váltak,  ezért is végeztem fittnes instruktorként.  3 éve megismertem és mindennapjaim részévé tettem a TRX edzést. Most már mint képzett TRX edző tartok edzéseket. \n\nFontosnak tartom a sport mellett az egészséges táplálkozást is, hisz a mozgás és a táplálkozás együtt a leghatásosabb. Mint táplálkozási tanácsadó szívesen segítek ebben is.  Mind a csoportos, mind az egyéni óráimon szempont a változatosság, öröm és a sérülések lehetséges megelőzése. \n\nMottóm: a szépség belülről fakad. \n\nCsoportos óra: 2.500 \nEgyéni edzés 4.000 ft/óra \nEgyéni edzés 2 fő esetén 3.000 ft/fő"
            },

            reka: {
                active: false,
                name: "Böröcz Réka",
                phone: "+36 30 974 9780",
                email: "mailto:torzsokreka@gmail.com",
                instagram: "https://instagram.com/rk.fitzone",
                image: "reka.jpeg",
                bio: "Böröcz Réka – Fitness instruktor, posztnatális tréner\n\nHiszem, hogy a mozgás nemcsak a testet, hanem a lelket is formálja. Posztnatális trénerként kiemelten fontosnak tartom a szülés utáni rehabilitációt és legfőbb célom, hogy segítsem az anyukákat biztonságosan, fokozatosan és önbizalommal telve visszatérni a mozgáshoz.\n\nSzeretném eloszlatni a főként nőket érintő, súlyzós edzéssel kapcsolatos félelmeket és tévhiteket és megmutatni, hogy az erő fejlesztése nem csak a külsőn változtat, hanem magabiztosabbá, energikusabbá és kiegyensúlyozottabbá tesz a mindennapokban is.\n\nNőként és anyaként tudom, milyen kihívásokkal jár időt szakítani magunkra, ezért edzéseimen a hatékonyságot, a biztonságot és a jó hangulatot helyezem előtérbe. Legyen szó szülés utáni regenerációról, saját testsúlyos, TRX vagy súlyzós edzésről, nálam mindenki megtalálja a saját tempóját és a fejlődés örömét.\n\nSzemélyi edzés: 5000 Ft/alkalom\nPáros edzés: 3500/fő/alkalom",
            },

            rita: {
                active: false,
                name: "Szalai Rita",
                phone: "+36 30 293 6002",
                email: "rszalai1@gmail.com",
                instagram: "",
                image: "rita.jpg",
                bio: "Sziasztok, Szalai Rita vagyok – csoportos edző, funkcionális tréner és életmód-tanácsadó.\n\nA mozgás gyerekkorom óta az életem része: 13 éven át táncoltam, majd aerobik és számos más mozgásforma következett. Az utóbbi években a funkcionális edzés és a crossfit lett a nagy szerelem – nemcsak formál, de megszűntette a derékfájásomat, és ellensúlyozza az ülőmunkát.\n\n**Végzettségeim**\n• Életmód- és táplálkozási tanácsadó (2020)\n• Funkcionális tréner (2022)\n• Csoportos fitness instruktor\n\nFolyamatosan képzem magam, különösen hormonális egyensúly, ételintoleranciák és speciális étrendek (vegetáriánus, gluténmentes) témakörében.\n\n**Amiben segíteni tudok**\n• Táplálkozási tanácsadás, életmódváltás támogatása\n• Ét­el­in­to­ler­an­cia esetén alternatív étrend\n• Vegetáriánus életmód támogatása (én is így étkezem)\n• Funkcionális és TRX edzések\n• Állóképesség, erőnlét fejlesztése\n• Testi-lelki egyensúly megteremtése\n\n**Árak**\n• Személyi edzés – 5 000 Ft / alkalom (maximális figyelemmel)\n• Páros edzés – 3 500 Ft / fő / alkalom\n• Csoportos edzés – 2 500 Ft / fő / alkalom\n\nÉrdeklődj üzenetben vagy a +36 30 293 6002 telefonszámon.\nE-mail: rszalai1@gmail.com"
            },

            mark: {
                name: "Kardos Márk",
                phone: "+36 20 313 8676",
                email: "mailto:markkardos.99@gmail.com",
                instagram: "https://instagram.com/kardosmark",
                image: "mark.jpg",
                bio: "Kardos Márk vagyok személyi edző/ testépítés -fitnesz sportoktató. \n\n12 éves korom óta életem része a sport, az edzői pályát pedig azért választottam, mert szeretnék másoknak is segíteni abban, hogy egészségesebbek, erősebbek és magabiztosabbak legyenek. \n\nMinden edzés egyéni célokra szabva történik. Naprakész tudás, motiváló hangulat és támogató hozzáállás vár rád minden alkalommal.\n\n Ha szeretnél fejlődni és jól érezni magad közben várlak sok szeretettel! \n\nElérhetőségek: \nTelefon: +36 20 313 8676 \nInstagram: kardosmark \nemail: markkardos.99@gmail.com"
            },

            kristof: {
                active: false,
                name: "Kuncz Kristóf",
                phone: "+36 30 870 3980",
                email: "mailto:kunczkristof.trainer@gmail.com",
                instagram: "https://instagram.com/kuncz.kristof",
                image: "kristof.jpg",
                bio: "Sziasztok, Kuncz Kristóf vagyok.\n\nTöbb, mint 10 év edzésmúlttal végre belekezdtem az edzősködésbe.\n\nMindig úgy állok hozzá az edzéshez, hogy a befektetett időt és energiát maximálisan visszakapjam eredményekben. Így az utóbbi években folyamatosan képeztem magam, hogy naprakész tudással és tapasztalattal tudjak szolgálni azoknak, akik a segítségemet kérik.\n\nMiben tudok segíteni neked?\n\n• személyi edzés\n• személyre szabott edzésterv\n• táplálkozási tanácsadás\n• étrend készítés\n\nEdzés árak\n• Személyi edzés: 5 000 Ft/alkalom\n• Páros edzés: 3 500 Ft/fő/alkalom\n\nBérlet árak\n• 8 alkalmas bérlet: 35 000 Ft\n• 12 alkalmas bérlet 50 000 Ft\n\nKészen állsz változtatni? Itt az idő, hogy elérd a céljaidat!\nKeress meg még ma, és kezdjük el az átalakulásod!\n\nÉrdeklődj telefonon, közösségi média felületeken, vagy emailben!",
            },

            istvan: {
                name: "Molnár István Márk",
                phone: "+36 20 482 4694",
                email: "mailto:molnaredzo@gmail.com",
                instagram: "https://instagram.com/mlnr_istvan",
                image: "istvan.jpg",
                bio: "Hobbi box edző. Hobbi box edzésekkel, személyre szabott edzéstervvel, állóképesség- és erőnlétfejlesztéssel, valamint technikai és étrendi segítséggel várlak."
            },
            balazs: {
                name: "Csata Balázs",
                phone: "+36 70 414 8877",
                email: "mailto:csatabalazs911@gmail.com",
                instagram: "https://instagram.com/balazs.csata",
                image: "balazs.jpg",
                bio: "Személyi edző. Személyi és páros edzéssel, személyre szabott edzéstervvel, táplálkozási tanácsadással és étrendkészítéssel segítek elérni a céljaidat."
            }

            /* 🔁  Add the remaining five trainers here.
               Keep the same property names so the JSX stays 100 % generic. */
        }
    },
    company: {
        title: "Impresszum",
        sectionTitle: "Cég és tárhely szolgáltató adatok",
        businessTitle: "Vállalkozás adatai",
        businessName: "Cégnév",
        address: "Székhely / Postai cím",
        taxNumber: "Adószám",
        regNumber: "Nyilvántartási szám",
        phone: "Telefonszám",
        email: "E-mail",
        bankAccount: "Bankszámlaszám",
        hostingTitle: "Tárhely szolgáltató adatai",
        hostingName: "Cégnév",
        hostingAddress: "Cím"
    },
    footer: {
        contactTitle: "Elérhetőségek",
        hoursTitle: "Nyitvatartás",
        hoursWeek: "Hétfő – Péntek: 6:00 – 22:00",
        hoursWeekend: "Szombat – Vasárnap: 8:00 – 20:00",
        followTitle: "Kövess minket",
        address: "Székesfehérvár, Budai út 154.",
        impresszumTitle: "Impresszum",
        creditPrefix: "Tervezte és készítette:",
        creditName: "Clarity Works"
    },
}

export default languagePack
